import styled from '@emotion/styled';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding: ${({ theme }) => theme.spacing[6]};
    gap: ${({ theme }) => theme.spacing[6]};
`;

export const FormCard = styled.div`
    background: ${({ theme }) => theme.color.white100};
    border-radius: ${({ theme }) => theme.radius.main};
    border: 1px solid ${({ theme }) => theme.color.grey200};
    padding: ${({ theme }) => theme.spacing[6]};
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[5]};
`;

export const Row = styled.div`
    display: flex;
    gap: ${({ theme }) => theme.spacing[4]};
    align-items: flex-start;

    & > * {
        flex: 1;
    }
`;

export const Field = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[2]};
    width: 100%;
`;

export const Hint = styled.div`
    color: ${({ theme }) => theme.color.grey500};
    font-size: ${({ theme }) => theme.font.size.small};
`;

export const TimeInput = styled.input`
    padding: ${({ theme }) => theme.spacing[2]} ${({ theme }) => theme.spacing[3]};
    border: 1px solid ${({ theme }) => theme.color.grey300};
    border-radius: ${({ theme }) => theme.radius.main};
    font-size: ${({ theme }) => theme.font.size.medium};
    color: ${({ theme }) => theme.color.black200};

    &:disabled {
        background: ${({ theme }) => theme.color.grey100};
        color: ${({ theme }) => theme.color.grey500};
        cursor: not-allowed;
    }
`;

export const ConfirmationBarContainer = styled.div`
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
`;

export const Header = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[2]};
`;
